import { MapAnnotation } from './map-annotation';
import { ChangedSpaceEvent } from './changed-space-event';
import { ObjectZoneRecommendation } from './object-zone-recommendation';
import { SmartScheduleRecommendation } from './schedule-recommendation';
import { FavoriteRecommendation } from './favorite-recommendation';
import { RobotHealthNotification } from './robot-health-notification';
import { ImageReview } from './image-review';

export class QAInsightEvent {
  public robot_id: string;
  public campaign_id: string;
  public robot_name?: string;
  public p2map_id?: string = null;
  public map_annotation?: MapAnnotation = null;
  public changed_space_event?: ChangedSpaceEvent = null;
  public object_zone_recommendation?: ObjectZoneRecommendation = null;
  public schedule_recommendation?: SmartScheduleRecommendation = null;
  public favorite_recommendation?: FavoriteRecommendation = null;
  public robot_health_notification?: RobotHealthNotification = null;
  public image_review?: ImageReview = null;
}
